import { useState, VFC } from 'react'
import {
  acceptInterested,
  rejectInterested,
  useRequestBoxes,
  useSentRequestBoxes,
} from 'src/api/requestBox'
import { useUser } from 'src/api/user'
import { DEFAULT_IMAGE } from 'src/assets/images'
import {
  GreenDownArrowIcon,
  GreenUpArrowIcon,
  RequestBoxPageBookIcon,
} from 'src/assets/svgs'
import { MemberPageWrapper } from 'src/components/PageWrapper'
import { SmallButton } from 'src/elements/Button'
import { RequestBoxCompany } from 'src/models/RequestBox'
import { LoginUser } from 'src/models/User'
import {
  _introductory_text_at,
  _profilehrborder,
  _requestbox_item_border,
  accentColor,
  black,
  contributionGray,
  lightgray,
  mediumGray,
  orange,
  truewhite,
} from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import { companyDetail, companyMessageTargetUrl } from 'src/utils/routes'
import styled, { css } from 'styled-components'
import { IntroductoryTextModal } from './IntroductoryTextModal'

type RequestBoxLayoutProps = {
  user: LoginUser
}
export const RequestBoxLayout: VFC<RequestBoxLayoutProps> = (props) => {
  const { user } = props
  return (
    <>
      <MemberPageWrapper user={user} currentPath="つながり一覧">
        <RequestBoxContent {...props} />
      </MemberPageWrapper>
    </>
  )
}

const RequestBoxContent: VFC<RequestBoxLayoutProps> = ({ user }) => {
  const { data: requestBoxResonse, mutate } = useRequestBoxes()
  const { data: sentRequestBoxResonse } = useSentRequestBoxes()
  const { data: copmanyResponse } = useUser(user.id)
  const companies = requestBoxResonse?.companies || []
  const requestedCountFromApi = requestBoxResonse?.requestedCount
  const requestedCompanies = companies.filter((company) => !company.matched)
  const matchedCompanies = companies.filter((company) => company.matched)
  const sentCompanies = sentRequestBoxResonse?.companies || []
  const introductoryTextCompanies =
    copmanyResponse?.company.introductoryTextCompanies || []

  const [targetCompany, setTargetCompany] = useState<RequestBoxCompany | null>(
    null,
  )

  const [currentTab, setCurrentTab] = useState<
    'requested' | 'matched' | 'introductory_text'
  >('requested')
  const isRequested = currentTab === 'requested'
  const isMatched = currentTab === 'matched'
  const isIntroductoryText = currentTab === 'introductory_text'

  const onInterested = async (companyId: number) => {
    await acceptInterested(companyId)
    location.href = companyMessageTargetUrl(companyId)
  }

  const onNotInterested = async (companyId: number) => {
    await rejectInterested(companyId)
    await mutate()
  }

  const showProfile = async (companyId: number) => {
    window.open(companyDetail(companyId, false, false), '_blank')
  }

  return (
    <RequestBoxListContainer>
      <RequestBoxTitle>
        <h2>つながり一覧</h2>
        <p>
          あなたとつながっている企業様を確認・承認・紹介文の閲覧ができます。
        </p>
      </RequestBoxTitle>
      <RequestBoxTabs>
        <RequestBoxTabItem
          onClick={() => setCurrentTab('requested')}
          $isCurrent={isRequested}
        >
          <p>つながりリクエスト</p>
        </RequestBoxTabItem>
        <RequestBoxTabItem
          onClick={() => setCurrentTab('matched')}
          $isCurrent={isMatched}
        >
          <p>つながり一覧</p>
        </RequestBoxTabItem>
        <RequestBoxTabItem
          onClick={() => setCurrentTab('introductory_text')}
          $isCurrent={isIntroductoryText}
        >
          <p>紹介文一覧</p>
        </RequestBoxTabItem>
      </RequestBoxTabs>
      {isRequested ? (
        <>
          {requestedCompanies.length > 0 ? (
            <>
              <RequestBoxWrapper>
                <RequestBoxPageBookIcon />
                <h1>
                  <AccentColorSpan>
                    {requestedCompanies.length}名
                  </AccentColorSpan>
                  からつながりリクエストが届いています！
                </h1>
              </RequestBoxWrapper>
              {requestedCompanies.map((company) => (
                <RequestBoxItem key={company.id}>
                  <Flex>
                    <RequestBoxItemDetail>
                      <Flex>
                        <ItemContentImage
                          src={company.imageUrl || DEFAULT_IMAGE}
                          onClick={() => showProfile(company.id)}
                        />
                        <ItemCompanyInfo>
                          <CompanyName>{company.name}</CompanyName>
                          <CompanyAdminName>
                            {company.adminName}
                          </CompanyAdminName>
                        </ItemCompanyInfo>
                      </Flex>
                      <ProfileButtonDiv>
                        <ProfileButton onClick={() => showProfile(company.id)}>
                          プロフィール確認
                        </ProfileButton>
                      </ProfileButtonDiv>
                    </RequestBoxItemDetail>
                    <Buttons>
                      <ApproveButton onClick={() => onInterested(company.id)}>
                        承認
                      </ApproveButton>
                      <DeniedButton onClick={() => onNotInterested(company.id)}>
                        非承認
                      </DeniedButton>
                    </Buttons>
                  </Flex>
                </RequestBoxItem>
              ))}
              <Spacer />
            </>
          ) : (
            <RequestBoxNoContent>
              つながりリクエストは届いていません。
            </RequestBoxNoContent>
          )}
          {sentCompanies.length > 0 ? (
            <>
              <RequestBoxWrapper>
                <RequestBoxPageBookIcon />
                <h1>
                  <AccentColorSpan>{sentCompanies.length}名</AccentColorSpan>
                  へつながりリクエストを送っています
                  <SmallSpan>（承認待ち）</SmallSpan>
                </h1>
              </RequestBoxWrapper>
              {sentCompanies.map((company) => (
                <RequestBoxItem key={company.id}>
                  <Flex>
                    <RequestBoxItemDetail>
                      <Flex>
                        <ItemContentImage
                          src={company.imageUrl || DEFAULT_IMAGE}
                          onClick={() => showProfile(company.id)}
                        />
                        <ItemCompanyInfo>
                          <CompanyName>{company.name}</CompanyName>
                          <CompanyAdminName>
                            {company.adminName}
                          </CompanyAdminName>
                        </ItemCompanyInfo>
                      </Flex>
                    </RequestBoxItemDetail>
                    <ButtonDiv>
                      <ApproveButton onClick={() => showProfile(company.id)}>
                        プロフィール確認
                      </ApproveButton>
                    </ButtonDiv>
                  </Flex>
                </RequestBoxItem>
              ))}
            </>
          ) : (
            <></>
          )}
        </>
      ) : isMatched ? (
        <>
          {matchedCompanies.length > 0 ? (
            <>
              <RequestBoxWrapper>
                <RequestBoxPageBookIcon />
                <h1>
                  つながり人数：
                  <AccentColorSpan>
                    {requestedCountFromApi != null
                      ? requestedCountFromApi
                      : matchedCompanies.length}
                    名
                  </AccentColorSpan>
                </h1>
              </RequestBoxWrapper>
              {matchedCompanies.map((company) => (
                <RequestBoxItem key={company.id}>
                  <Flex>
                    <RequestBoxItemDetail>
                      <Flex>
                        <ItemContentImage
                          src={company.imageUrl || DEFAULT_IMAGE}
                          onClick={() => showProfile(company.id)}
                        />
                        <ItemCompanyInfo>
                          <CompanyName>{company.name}</CompanyName>
                          <CompanyAdminName>
                            {company.adminName}
                          </CompanyAdminName>
                        </ItemCompanyInfo>
                      </Flex>
                      <ProfileButtonDiv>
                        <ProfileButton onClick={() => showProfile(company.id)}>
                          プロフィール確認
                        </ProfileButton>
                      </ProfileButtonDiv>
                    </RequestBoxItemDetail>
                    <ButtonDiv>
                      <IntroductoryTextEditButton
                        onClick={() => setTargetCompany(company)}
                      >
                        紹介文編集
                      </IntroductoryTextEditButton>
                    </ButtonDiv>
                  </Flex>
                </RequestBoxItem>
              ))}
            </>
          ) : (
            <RequestBoxNoContent>つながりはありません。</RequestBoxNoContent>
          )}
        </>
      ) : isIntroductoryText ? (
        <>
          {introductoryTextCompanies.length > 0 ? (
            <>
              {introductoryTextCompanies.map((company) => (
                <IntroductoryTextItem key={company.id}>
                  <Flex>
                    <IntroductoryTextItemDetail>
                      <ItemContentImage
                        src={company.imageUrl || DEFAULT_IMAGE}
                        onClick={() => showProfile(company.id)}
                      />
                      <ItemCompanyInfo>
                        <CompanyName>{company.name}</CompanyName>
                        <CompanyAdminName>{company.adminName}</CompanyAdminName>
                      </ItemCompanyInfo>
                    </IntroductoryTextItemDetail>
                    <IntroductoryTextWrapper>
                      <IntroductoryTextDiv>
                        <DisplayIntroductoryText content={company.content} />
                      </IntroductoryTextDiv>
                      <IntroductoryTextAt>
                        {company.createdAt.format('YYYY/MM/DD HH:mm')}
                      </IntroductoryTextAt>
                    </IntroductoryTextWrapper>
                  </Flex>
                </IntroductoryTextItem>
              ))}
            </>
          ) : (
            <RequestBoxNoContent>紹介文はありません。</RequestBoxNoContent>
          )}
        </>
      ) : (
        <></>
      )}
      {targetCompany && (
        <IntroductoryTextModal
          close={() => setTargetCompany(null)}
          company={targetCompany}
          mutate={mutate}
        />
      )}
    </RequestBoxListContainer>
  )
}

export const DisplayIntroductoryText: VFC<{ content: string }> = ({
  content,
}) => {
  const [showContent, setShowContent] = useState<boolean>(false)
  const CONTENT_LIMIT = 200
  return (
    <>
      {content.length > CONTENT_LIMIT ? (
        <>
          {!showContent && (
            <>
              <div>{content.slice(0, CONTENT_LIMIT)}...</div>
              <IntroductoryTextButton onClick={() => setShowContent(true)}>
                <GreenDownArrowIcon />
                <IntroductoryTextSpan>もっと見る</IntroductoryTextSpan>
              </IntroductoryTextButton>
            </>
          )}
          {showContent && (
            <>
              <div>{content}</div>

              <IntroductoryTextButton onClick={() => setShowContent(false)}>
                <GreenUpArrowIcon />
                <IntroductoryTextSpan>閉じる</IntroductoryTextSpan>
              </IntroductoryTextButton>
            </>
          )}
        </>
      ) : (
        <div>{content}</div>
      )}
    </>
  )
}

const RequestBoxListContainer = styled.div`
  max-width: 860px;
  margin: 0 auto;
`

const RequestBoxTitle = styled.div`
  font-weight: ${fontWeightBold};
  margin-bottom: 24px;

  h2 {
    font-size: 20px;
    margin: 24px 0px;
  }
  p {
    line-height: 20px;
  }
`

const RequestBoxTabs = styled.div`
  display: flex;
  padding: 0px 10px;
  border-bottom: 2px solid ${_profilehrborder};
  margin-bottom: 20px;
`

const RequestBoxTabItem = styled.a<{ $isCurrent: boolean }>`
  max-width: 170px;
  font-size: 14px;
  letter-spacing: 1px;
  font-weight: ${fontWeightBold};
  text-align: center;
  margin-right: 30px;
  color: ${contributionGray};

  p {
    padding: 16px;
  }

  :hover,
  :focus {
    color: ${orange};
  }

  ${({ $isCurrent }) =>
    $isCurrent &&
    `
      border-bottom: 3px solid ${accentColor};
      color: ${black};
    `};
`

const RequestBoxWrapper = styled.div`
  padding: 20px 10px;
  display: flex;
  align-items: center;

  h1 {
    margin-left: 12px;
    font-size: 18px;
    font-weight: ${fontWeightBold};
    color: ${mediumGray};
  }
`
const AccentColorSpan = styled.span`
  color: ${accentColor};
`
const SmallSpan = styled.span`
  font-size: 12px;
`
const Spacer = styled.div`
  margin-bottom: 20px;
`
const Flex = styled.div`
  display: flex;
`
const RequestBoxItem = styled.div`
  border-radius: 20px;
  border: 1px solid ${_requestbox_item_border};
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
  margin-bottom: 30px;
`
const RequestBoxItemDetail = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 20px;
  border-right: 2px solid ${_requestbox_item_border};
`
const ItemContentImage = styled.img`
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
  width: 110px;
  height: 110px;
  margin-right: 16px;
`
const ItemCompanyInfo = styled.div`
  width: 200px;
`
const CompanyName = styled.p`
  padding-top: 20px;
  padding-bottom: 4px;
`
const CompanyAdminName = styled.p`
  font-size: 20px;
  font-weight: ${fontWeightBold};
`
const RequestBoxNoContent = styled.p`
  line-height: 100px;
  text-align: center;
`
const ProfileButtonDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
`
const ProfileButton = styled(SmallButton)`
  width: 160px;
  border: 1px solid ${accentColor};
  color: ${accentColor};
  font-weight: ${fontWeightBold};
`
const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 264px;
  padding: 0 30px;
  color: ${truewhite};
`
const buttonCss = css`
  height: 42px;
  margin: 6px 0;
  width: 204px;
  padding: 10px 0;
`
const ApproveButton = styled(SmallButton)`
  background: ${accentColor};
  ${buttonCss}
  color: ${truewhite};
`
const DeniedButton = styled(SmallButton)`
  background: ${lightgray};
  ${buttonCss}
  color: ${truewhite};
`
const ButtonDiv = styled.div`
  width: 264px;
  padding: 15px 30px;
`
const IntroductoryTextItem = styled.div`
  border-radius: 20px;
  border: 1px solid ${_requestbox_item_border};
  margin-bottom: 30px;
`
const IntroductoryTextItemDetail = styled.div`
  display: flex;
  padding: 20px;
  border-radius: 20px 0px 0px 20px;
  box-shadow: 3px 6px 10px rgba(0, 0, 0, 0.25);
`
const IntroductoryTextWrapper = styled.div`
  display: flex;
  width: 475px;
  position: relative;
`
const IntroductoryTextDiv = styled.div`
  padding: 20px;
  margin-bottom: 8px;
  font-size: 12px;
  white-space: pre-wrap;
`
const IntroductoryTextAt = styled.p`
  position: absolute;
  bottom: 10px;
  right: 0;
  text-align: right;
  font-size: 12px;
  color: ${_introductory_text_at};
`
const IntroductoryTextEditButton = styled(SmallButton)`
  border: 1px solid ${accentColor};
  ${buttonCss}
  color: ${accentColor};
`
const IntroductoryTextButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: ${fontWeightBold};
  padding: 16px 0px;
  cursor: pointer;
  color: ${accentColor};
`
const IntroductoryTextSpan = styled.span`
  margin-left: 8px;
`
